/* JD Promo popup — Jeremić Satovi
   - otvara se posle kašnjenja (data-delay), jednom po sesiji (sessionStorage, ključ data-key)
   - posle osvežavanja stranice (refresh) se ponovo prikazuje (data-reload="1"), pri prelasku na drugu stranicu ne
   - zatvaranje: X, klik na pozadinu, Esc; fokus ostaje u popupu i vraća se posle zatvaranja
   - u uređivaču teme se otvara kada se sekcija izabere */
(function () {
  if (customElements.get('jd-promo-popup')) return;

  class JdPromoPopup extends HTMLElement {
    connectedCallback() {
      this.key = this.dataset.key || 'jd-promo';
      this.once = this.dataset.once === '1';
      this.showOnReload = this.dataset.reload === '1';
      this.isOpen = false;

      if (window.Shopify && window.Shopify.designMode) {
        document.addEventListener('shopify:section:select', (e) => {
          if (e.detail && e.detail.sectionId === this.dataset.sectionId) this.open();
        });
        document.addEventListener('shopify:section:deselect', (e) => {
          if (e.detail && e.detail.sectionId === this.dataset.sectionId) this.close(false);
        });
        return;
      }

      if (this.once && this.wasClosed() && !(this.showOnReload && this.isReload())) return;
      const delay = parseInt(this.dataset.delay || '1000', 10);
      setTimeout(() => this.open(), isNaN(delay) ? 1000 : delay);
    }

    // da li je stranica učitana osvežavanjem (refresh), a ne prelaskom sa druge stranice
    isReload() {
      try {
        const nav = performance.getEntriesByType ? performance.getEntriesByType('navigation')[0] : null;
        if (nav) return nav.type === 'reload';
        return !!(performance.navigation && performance.navigation.type === 1);
      } catch (e) {
        return false;
      }
    }

    wasClosed() {
      try { return window.sessionStorage.getItem(this.key) === '1'; } catch (e) { return false; }
    }

    remember() {
      if (!this.once) return;
      try { window.sessionStorage.setItem(this.key, '1'); } catch (e) { /* privatni režim */ }
    }

    render() {
      if (this.rendered) return;
      const tpl = this.querySelector('template');
      if (!tpl) return;
      this.appendChild(tpl.content.cloneNode(true));
      this.rendered = true;
      this.dialog = this.querySelector('.jd-pp__dialog');
      this.querySelectorAll('[data-jd-pp-close]').forEach((el) => el.addEventListener('click', () => this.close(true)));
      const link = this.querySelector('[data-jd-pp-link]');
      if (link) link.addEventListener('click', () => this.remember());
      this.addEventListener('keydown', (e) => this.onKeydown(e));
      // klik na prazan prostor oko slike (van dijaloga) takodje zatvara
      this.addEventListener('click', (e) => { if (e.target === this) this.close(true); });
    }

    open() {
      if (this.isOpen) return;
      // ne otvaraj preko otvorene korpe ili menija
      if (document.querySelector('cart-drawer.active, details[open] > .menu-drawer')) {
        setTimeout(() => this.open(), 2000);
        return;
      }
      this.render();
      if (!this.dialog) return;
      this.previousFocus = document.activeElement;
      this.hidden = false;
      document.body.classList.add('overflow-hidden');
      void this.offsetWidth; // reflow, da animacija krene od pocetnog stanja
      this.classList.add('is-open');
      this.isOpen = true;
      const closeBtn = this.querySelector('.jd-pp__close');
      (closeBtn || this.dialog).focus({ preventScroll: true });
    }

    close(remember) {
      if (!this.isOpen) return;
      this.isOpen = false;
      this.classList.remove('is-open');
      if (remember !== false) this.remember();
      document.body.classList.remove('overflow-hidden');
      setTimeout(() => { if (!this.isOpen) this.hidden = true; }, 350);
      if (this.previousFocus && typeof this.previousFocus.focus === 'function') {
        this.previousFocus.focus({ preventScroll: true });
      }
    }

    onKeydown(e) {
      if (e.key === 'Escape') {
        e.preventDefault();
        this.close(true);
        return;
      }
      if (e.key !== 'Tab') return;
      const items = Array.from(this.querySelectorAll('button, a[href]'));
      if (!items.length) return;
      const first = items[0];
      const last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  }

  customElements.define('jd-promo-popup', JdPromoPopup);
})();
